/* global window */
/* eslint-disable consistent-return */
import React, { PureComponent } from "react";
import { Input, FormGroup, Col, Label } from "reactstrap";
import axios from "axios";
//import AutocompleteLocations from './AutocompleteLocations'
import GNAddressFormat from "../../../helpers/GNAddressFormat.js";
import placesAPI from "../../../helpers/placesAPI";

const debounce = (fn, time) => {
  let timeout;

  return function() {
    const functionCall = () => fn.apply(this, arguments);

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
};

class AutocompleteLocations extends PureComponent {
  static defaultProps = {
    locations: [],
    onItemSelect: {}
  };

  constructor(props) {
    super(props);
    this.onLocationSelect = this.onLocationSelect.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.locations !== this.props.locations) {
      this.setState({ locations: nextProps.locations });
    }
  }

  onLocationSelect(location) {
    return () => {
      if (this.props.onItemSelect) {
        // for address autocomplete we need the whole object to geocode,
        // for city we just need the string of the name
        this.props.onItemSelect(location);
      }
    };
  }

  renderLocationsList() {
    return this.props.locations.map((location, idx) => (
      <li
        key={location.id}
        className={`location-list-item ${
          this.props.cursor === idx ? "active" : ""
        }`}
        onMouseOver={this.onMouseOver}
        data-location-value={`${location.title}, ${location.vicinity}`}
        onClick={this.onLocationSelect(location)}
      >
        {location.title}, {location.vicinity}
      </li>
    ));
  }
  render() {
    return this.props.locations && this.props.locations.length ? (
      <ul className="autocomplete-list-wrapper">
        {this.renderLocationsList()}
      </ul>
    ) : null;
  }
}

class AddressInput extends PureComponent {
  constructor(props) {
    super(props);
    this.autocompleteService = false;
    this.geocoder = false;

    this.firstLocationUpdate = false;

    this.state = {
      autocompleteLocations: [],
      addressSearchValue: "",
      value: this.props.value,
      valueString: null
    };
    this.autocomplete = this.autocomplete.bind(this);
    this.onLocationSelect = this.onLocationSelect.bind(this);
    this.onLocationInput = this.onLocationInput.bind(this);
    this.onAutoComplete = this.onAutoComplete.bind(this);
    this.autocompleteDebounced = debounce(this.autocomplete, 500);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.clearValue) {
      this.setState({ value: "" });
    }
  }

  onLocationInput(e) {
    e.persist();
    this.setState({ value: e.target.value });
    const searchValue = e.target.value;
    if (searchValue.length > 0) {
      this.autocompleteDebounced(searchValue);
    } else {
      this.setState({ autocompleteLocations: [] });
    }

    e.preventDefault();
  }

  onLocationSelect(autofillLocation) {
    this.setState({
      autocompleteLocations: false,
      value: autofillLocation,
      locationString: `${autofillLocation.title}, ${autofillLocation.vicinity}`
    });

    this.geocodeAddress(autofillLocation);
  }

  onAutoComplete(prediction) {
    this.setState({
      autocompleteLocations: prediction
    });
  }

  autocomplete(query) {
    placesAPI
      .autocompleteAddress(query)
      .then(({ data }) => {
        this.onAutoComplete(data.results);
      })
      .catch(err => {
        console.log(err);
      });
  }

  onGeocodeSuccess(results) {
    const updateLocation = placesAPI.formatResponseAddress(results);
    this.props.onUpdateLocation(updateLocation);
  }

  onGeocodeError(err) {
    console.log(err);
  }

  onSubmit(e) {
    e.preventDefault();
    this.geocodeAddress(this.state.value);
  }

  geocodeAddress(address) {
    axios
      .get(address.href)
      .then(({ data }) => {
        this.onGeocodeSuccess(data);
      })
      .catch(err => {
        console.log(err);
        this.onGeocodeError(err.response);
      });
  }

  render() {
    return (
      <section>
        <div className={"address-search-box-wrapper"}>
          <FormGroup row>
            <Col xs="6">
              <FormGroup>
                <Label htmlFor="location">Location (required)</Label>
                {this.props.selectedLocation.address && (
                  <p>{GNAddressFormat(this.props.selectedLocation.address)}</p>
                )}
                <Input
                  type="text"
                  placeholder={
                    this.state.addressSearchValue
                      ? this.state.addressSearchValue
                      : "Begin typing an address..."
                  }
                  onChange={this.onLocationInput}
                  value={this.state.locationString}
                />
              </FormGroup>
              <AutocompleteLocations
                locations={this.state.autocompleteLocations}
                ref={r => {
                  this.autocompleteList = r;
                }}
                onItemSelect={this.onLocationSelect}
              />
              {/* <div className={"input-block-actions"}>
                <button className="btn btn-primary" onClick={this.onSubmit}>
                  Set Location
                </button>
              </div> */}
            </Col>
          </FormGroup>
        </div>
      </section>
    );
  }
}

export default AddressInput;



// WEBPACK FOOTER //
// ./src/views/Components/AddressInput/AddressInput.js